import { Injectable } from '@angular/core';

import { Consorcio } from '../model/Consorcio';
import { Usuario } from '../model/usuario';
import { UsuarioSucursal } from '../model/usuario-sucursal';
import { Seguridad } from '../model/seguridad';


import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service';


@Injectable()
export class UsuarioService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }


  getUsuarios(): Observable<Usuario[]> {

    let json = { "Metodo": "getUsuario", "Datos": {} };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  findUsuarios(query: string): Observable<Usuario[]> {

    let json = { "Metodo": "findUsuario", "Datos": { queryText: query } };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  public insert(usuario: Usuario) {

    let json = { "Metodo": "postUsuario", "Datos": usuario };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());

  }

  public delete(usuario: Usuario) {

    let json = { "Metodo": "deleteUsuario", "Datos": usuario };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }


  public seguridad(query: any): Observable<Seguridad[]> {

    let json = { "Metodo": "seguridadUsuario", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/usuario.service.ts